import React from "react";
import { Modal, ModalBody, ModalFooter, FormGroup } from "reactstrap";
import MaskedInput from "react-text-mask";
import "./pos-modal.css";

export default function CustomerDataModal({
  isOpen,
  onClose,
  customer,
  onUpdateCustomer,
  onUpdateCustomerPhone,
  onUpdateCustomerCpf,
}) {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md" className="pos-modal">
      <div className="modal-header">
        <span className="modal-title">Dados do cliente</span>
        <button className="pos-modal-close-btn" onClick={onClose}>×</button>
      </div>

      <ModalBody>
        <FormGroup className="mb-3">
          <label className="pos-modal-label">Nome</label>
          <input
            type="text"
            placeholder="Nome do cliente"
            value={customer.name}
            onChange={(e) => onUpdateCustomer("name", e.target.value)}
            className="form-control pos-modal-input"
          />
        </FormGroup>

        <FormGroup className="mb-3">
          <label className="pos-modal-label">E-mail</label>
          <input
            type="email"
            value={customer.email}
            onChange={(e) => onUpdateCustomer("email", e.target.value)}
            className="form-control pos-modal-input"
          />
        </FormGroup>

        <FormGroup className="mb-3">
          <label className="pos-modal-label">Celular</label>
          <MaskedInput
            mask={[
              "(",
              /[1-9]/,
              /\d/,
              ")",
              " ",
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ]}
            className="form-control pos-modal-input"
            value={customer.phone_numbers[0]}
            placeholder="(00) 0 0000-0000"
            onChange={(e) => onUpdateCustomerPhone(e.target.value)}
          />
        </FormGroup>

        <FormGroup className="mb-0">
          <label className="pos-modal-label">CPF</label>
          <input
            type="text"
            placeholder="000.000.000-00"
            value={customer.documents[0]?.number ?? ""}
            onChange={(e) => onUpdateCustomerCpf(e.target.value)}
            className="form-control pos-modal-input"
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <button
          className="pos-modal-btn pos-modal-btn--primary"
          onClick={onClose}
        >
          Confirmar
        </button>
      </ModalFooter>
    </Modal>
  );
}
